import './roles-permissions.scss';

import PropTypes from 'prop-types';
import React from 'react';

const RolesPermissions = ({ roles }) => {
  return (
    <div className="roles-permissions">
      <div className="roles-permissions__header">
        <h2>Roles &amp; Permissions</h2>
        <p>Control access with roles.</p>
      </div>

      <div className="roles-permissions__grid">
        {roles.map((role) => (
          <div key={role.name} className="roles-permissions__card">
            <h3>{role.name}</h3>
            <p>{role.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

RolesPermissions.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ).isRequired
};

export default RolesPermissions;
